import { render, staticRenderFns } from "./ChartsSection.vue?vue&type=template&id=0d06d69c&scoped=true"
import script from "./ChartsSection.vue?vue&type=script&lang=js"
export * from "./ChartsSection.vue?vue&type=script&lang=js"
import style0 from "./ChartsSection.vue?vue&type=style&index=0&id=0d06d69c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d06d69c",
  null
  
)

export default component.exports